import { render, staticRenderFns } from "./StudentTaskOf.vue?vue&type=template&id=0245f97e&scoped=true&"
import script from "./StudentTaskOf.vue?vue&type=script&lang=js&"
export * from "./StudentTaskOf.vue?vue&type=script&lang=js&"
import style0 from "./StudentTaskOf.vue?vue&type=style&index=0&id=0245f97e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0245f97e",
  null
  
)

export default component.exports